import Plain from './plain'

export default Plain
